import { semantical } from 'src/theme/tokens/semantical';

export const dividerTheme = {
  variants: {
    primary: semantical.colors.background.neutral.strongest,
    secondary: semantical.colors.background.neutral.stronger,
    tertiary: semantical.colors.background.neutral.strong,
  },
};
